module.exports = __webpack_public_path__ + "media/images/admin/icons/anchor-7af672693c22d4ab02902065f7cf403f.svg";